/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ExtrasEnum = (typeof ExtrasEnum)[keyof typeof ExtrasEnum];

export const ExtrasEnum = {
  wifi: 'wifi',
  tv: 'tv',
  streaming: 'streaming',
  desk: 'desk',
  pool: 'pool',
} as const;
